var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.333 8.26a2.46 2.46 0 11-.04-4.92 2.46 2.46 0 01.04 4.92zm0-3.747a1.293 1.293 0 10-.04 2.587 1.293 1.293 0 00.04-2.587zM7.333 14.553a6.56 6.56 0 01-5.12-2.42l-.146-.18v-.233a3.26 3.26 0 013.266-3h4a3.26 3.26 0 013.227 3v.233l-.147.18a6.566 6.566 0 01-5.08 2.42zM3.28 11.587a5.42 5.42 0 008.067 0 2.087 2.087 0 00-2-1.7H5.333a2.08 2.08 0 00-2.053 1.7zM12.913 2.667h-1.166V6h1.166V2.667z",
    fill: "#121314"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.747h-3.333v1.166H14V3.747z",
    fill: "#121314"
  })));
}
export default SvgMedium;